<template>
  <div>
    <StringArray
      class="mb-2"
      object-name="election"
      :attribute-name="attribute"
      :items="items.filter((item) => item !== '*')"
      :placeholder="$t('js.backend.election_config.override.statistics__segments.new_segment')"
      :disabled="statisticsSegments"
      v-show="!statisticsSegments"
    />
  </div>
</template>

<script>
import StringArray from '../attributes/StringArray.vue';

export default {
  name: 'StatisticsSegments',
  components: { StringArray },
  props: {
    attribute: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      statisticsSegments: this.items.includes('*'),
    };
  },
};
</script>
